<template>
    <div :class="{ 'can-change': is_editable }" :key="volume_prix_chart_key" >
        <el-line-chart v-show="!volume_prix_data.error" name="volume_prix" :values="volume_prix_data" :height="200" />
        <div v-if="volume_prix_data.error" style="height: 200px"></div>
        <p class="source">
            Prix des ventes en collectif libre neuf, TVA pleine, avec stat.
        </p>
        <form v-if="is_editable && manual_edit" class="manual-edition">
            <el-table class="" :table="table_volume_prix" :component="data" @changed_value="changed_value($event)"/>
        </form>

        <!-- Display error div -->
        <div  v-if="is_edit_mode && ((volume_prix_data && volume_prix_data.error) || (table_volume_prix && table_volume_prix.error)) "  class="error-container edit-error">
             <div class='content-error'>{{volume_prix_data.error_message}} </div>
        </div>
        <div  v-if="!is_edit_mode && ((volume_prix_data && volume_prix_data.error) || (table_volume_prix && table_volume_prix.error)) "  class="error-container read-error">
             <div class='content-error'>{{volume_prix_data.error_message}} </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import ElLineChart from "@/components/study/editor/elements/el-line-chart";
import ElTable from "@/components/study/editor/elements/el-table";

export default {
	name: "el-promo-volume-prix",
	mixins: [ElementMixin],
	props: {
		is_OIP: { default: false },
		is_non_obs: { default: true },
		last_year_period: { default: null },
		data: {default: undefined},
		zone_geo: {default: undefined},
		zone_geo_quartier: {default: undefined},
		zone_geo_secteur: {default: undefined},
		showChart: {default: true}
	},
	data () {
		return {
			volume_prix_chart_key: 0,
			copy_data: undefined
		};
	},
	computed: {
		...mapGetters(["active_study", "etude_data","editor"]),
		parameters () {
			try {
				const parametersPromo =
				this.active_study.qlikData.parameters.editmode.find((editmode) => {return editmode.theme == "marche_promotion_immobiliere";});
				return parametersPromo;
			} catch (e) {
				return false;
			}
		},
		manual_edit () {
			return this.is_OIP || this.is_non_obs;
		},
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		},
		table_volume_prix () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [20, 20, 20, 20, 20],
				},
			};

			try{
				//todelete : switch mode error/nominal (false => error case)
				//this.data.valid = true;
				//throw "il y a une erreur"
				if( this.data.valid == false){
					table.error = true;
					// table.error_message = "[BACK-TAB-EDIT] : "+this.data.errorMessage;
					table.error_message = "Donnée non disponible!";
                    
				}
				else{
					let elem;
					if(this.zone_geo == "quartier") {
                        
						if(this.zone_geo_quartier == undefined)
							return table;
						elem = this.data.content.quartiers.find((quartier) => {
							return quartier.code == this.zone_geo_quartier;
						});
					}else if(this.zone_geo == "secteurs_adequation") {
						elem = this.data.content.secteurs_adequation.find((secteur) => {
							return secteur.code == this.zone_geo_secteur;
						});
					}else{
						elem = this.data.content[this.zone_geo];
					}
                    
					for (let i = 0;i < elem.header_list.length; i++) {
						table.body.push([{
							parent_data: elem.header_list[i],
							property: "value",
							format: "number",
							editable: "true"
						},
						{
							parent_data: elem.data_list[i].mises_en_vente,
							property: "value",
							format: "number",
							editable: "true"
						},
						{
							parent_data: elem.data_list[i].ventes_nettes,
							property: "value",
							format: "number",
							editable: "true"
						},
						{
							parent_data: elem.data_list[i].offre_commerciale,
							property: "value",
							format: "number",
							editable: "true"
						},
						{
							parent_data: elem.data_list[i].prix_m2_libre_avec_pkg,
							property: "value",
							format: "number",
							editable: "true"
						}
						]);
					}

					const trimestreMaj = this.parameters.periods.values.find((val) => {
						return val.code == this.last_year_period;
					});
					const liste_annee = trimestreMaj.periods.find((per) => {
						return per.component_id == "volumes_prix" || per.component_id == "4.2" ;
					}).values;

					table.body = table.body.filter((elem) => {
						const result = liste_annee.split(",").indexOf(elem[0].parent_data.value) > -1;
						return result;
					});

					table.head.push(["Année", "Mises en vente", "Ventes nettes", "Offre", "Prix/m² libre\navec stat."]);
				}
			} catch(error){
				table.error = true;
				// table.error_message = "[FRONT-TAB-EDIT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				table.error_message = "Donnée non disponible!";
			}
			return table;
		},
		volume_prix_data () {

			const temp = {datasets: [], labels: []};
			const keys = {
				mises_en_vente: { label: "Mises en vente", color: "#03A9F4", data: [] },
				offre_commerciale: { label: "Offre commerciale", color: "#f44336", data: [] },
				prix_m2_libre_avec_pkg: { label: "Prix / m ² avec stat.", color: "#FF9800", data: [] },
				ventes_nettes: { label: "Ventes nettes", color: "#8BC34A", data: [] },
			};
			try{
				if(!this.showChart){
					throw new Error("Pas assez de données");
				}
				//todelete : switch mode error/nominal (false => error case)
				// this.data.valid = true;
				//throw "il y a une erreur"
				
				if( this.data.valid == false){
					temp.error = true;
					// temp.error_message = "[BACK-GRAPH] : "+this.data.errorMessage;
					temp.error_message = "Donnée non disponible";
				}
				else{
					let elem;
					if(this.zone_geo == "quartier") {
						if(this.zone_geo_quartier == undefined)
							return temp;
						elem = this.data.content.quartiers.find((quartier) => {
							return quartier.code == this.zone_geo_quartier;
						});
					}else if(this.zone_geo == "secteurs_adequation") {
						if(this.data.content.secteurs_adequation)
							elem = this.data.content.secteurs_adequation.find((secteur) => {
								return secteur.code == this.zone_geo_secteur;
							});
						else
							return temp;
					}else{
						elem = this.data.content[this.zone_geo];
					}

					elem.data_list.forEach((data) => {
						Object.entries(data).forEach((type) => {
							keys[type[0]].data.push(type[1].value.replace(",", "."));
                            
							keys[type[0]].borderColor = keys[type[0]].color;
							keys[type[0]].backgroundColor = keys[type[0]].color;
							keys[type[0]].fill = false;
							keys[type[0]].pointStyle = "dot";
							keys[type[0]].pointRadius = 4;
							keys[type[0]].pointBackgroundColor = "#fff";
							keys[type[0]].pointBorderColor = keys[type[0]].color;
							keys[type[0]].pointBorderWidth = 2;
							keys[type[0]].yAxisID = this.data.meta_data[type[0]].axis == "left" ? "A" : "B";
						});

					});
					temp.datasets = Object.values(keys);
					
					const indexPrix = Object.keys(temp.datasets).find(key => temp.datasets[key].label == "Prix / m ² avec stat.");
				
					temp.datasets[indexPrix].data.forEach(function (element, index, arr) {
						if(element.toString() === "0" || element.toString() === "-"){
							arr[index] = null;
						}
					});

					const labels = elem.header_list.reduce((accu, curr) => {
						accu.push(curr.value);
						return accu;
					}, []);

					temp.labels = labels;

					const toDelete = [];

					const trimestreMaj = this.parameters.periods.values.find((val) => {
						return val.code == this.last_year_period;
					});
					const liste_annee = trimestreMaj.periods.find((per) => {
						return per.component_id == "volumes_prix" || per.component_id == "4.2" ;
					}).values;
					temp.labels.forEach((elem, i) => {
						if(liste_annee.split(",").indexOf(elem) == -1)
							toDelete.push(i);
					});

					for(let i = toDelete.length - 1 ; i >= 0 ; i--) {
						temp.labels.splice(toDelete[i], 1);
						temp.datasets.forEach((dataset) => {
							dataset.data.splice(toDelete[i], 1);
						});
					}
				}

			} catch(error){
				//console.log("============== here =============");
				console.error(error);
				temp.error = true;
				// temp.error_message = "[FRONT-GRAPH] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				temp.error_message = "Donnée non disponible";
			}
			return temp;
		},
	},
	methods: {
		updateCharts () {
			this.volume_prix_chart_key += 1;
		},
		changed_value: function (event){
			let elem;
			if(this.zone_geo == "quartier") {
				elem = this.copy_data.content.quartiers.find((quartier) => {
					return quartier.code == this.zone_geo_quartier;
				});
			}else if(this.zone_geo == "secteurs_adequation") {
				elem = this.copy_data.content.secteurs_adequation.find((secteur) => {
					return secteur.code == this.zone_geo_secteur;
				});
			}else{
				elem = this.copy_data.content[this.zone_geo];
			}

			if(event.element == 0){
				elem.header_list[event.line].value = event.value;
			}else{
				let place;
				switch (event.element) {
				case 1:
					place = "mises_en_vente";
					break;
				case 2:
					place = "ventes_nettes";
					break;
				case 3:
					place = "offre_commerciale";
					break;
				case 4:
					place = "prix_m2_libre_avec_pkg";
					break;
				default:
					break;
				}
				elem.data_list[event.line][place].value = event.value;
			}

			this.$store.commit("SET_COMPONENT", {id: 2, content: this.copy_data});
			this.$store.dispatch("save_study");
		}
	},
	created () {
		this.$store.subscribe((mutation) => {
			if (mutation.type === "SET_STUDY_STATE") {
				if (mutation.payload && mutation.payload.saving === true) {
					this.updateCharts();
				}
			}
			if (mutation.type === "SET_EDITOR_STATE") {
				if (mutation.payload && mutation.payload.mode === "viewing") {
					this.updateCharts();
				}
			}
		});
		this.copy_data = this.data;
	},
	components: {
		ElLineChart,
		ElTable,
	},
	watch: {
		last_year_period: function () {
			this.$forceUpdate();
			this.volume_prix_chart_key++;
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.error-container
    display flex
    justify-content center
    align-items center
    z-index: 990000
    position absolute
    top 0
    left 0
    width 100% !important
    height 100% !important
    text-align center
    border-style solid
    border-width 2px

.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red

.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58

.manual-edition
    height 160px
    background-color alpha(white, 85%)
    // border 2px dashed purple
    position absolute
    left 0
    top 0px
    right 0
    bottom 0
</style>
